import angular from "angular";
import SockJS from "sockjs-client";

angular
  .module('ons-actionslider', ['ngAnimate'])
  .constant('SockJS', SockJS)
  .constant('ONSAS_VERSION', '1.8.5')
  .factory('onsActionSocket', onsActionSocket)
  .directive('onsActionslider', onsActionslider)
  .directive('onsAction', onsAction);

onsActionslider.$inject = [];

/**
 * ons-actionslider element.
*
 * @type {import("angular").IDirectiveFactory}
 */
function onsActionslider () {
  return {
    restrict: 'E',
    controller: OnsActionsliderController,
    scope: {
      actionSession: '@',
      userId: '@',
      productId: '@',
      channels: '@',
      actionService: '@',
      maxActions: '@?',
      lifetime: '@?',
      language: '@?',
      onAction: '&',
      onScroll: '&',
      onClick: '&'
    },
    template: [
      '<div class="onsas-button onsas-first" ng-click="updateOffset(\'first\')">', '&nbsp;', '</div>',
      '<div class="onsas-button onsas-prev" ng-click="updateOffset(+1)">', '&nbsp;', '</div>',
      '<div class="onsas-actions">',
      '<ul class="onsas-no-anim">',
      '<li ons-action ng-class="action.classes" ng-repeat="action in actions track by action.timestamp" ng-click="onClick({action: action })">', '</li>',
      '</ul>',
      '</div>',
      '<div class="onsas-button onsas-next" ng-click="updateOffset(-1)">', '&nbsp;', '</div>',
      '<div class="onsas-button onsas-last" ng-click="updateOffset(\'last\')">', '&nbsp;', '</div>'
    ].join('')
  };
}

OnsActionsliderController.$inject = ['onsActionSocket', '$element', '$scope', '$filter', '$timeout', '$log', '$q', '$window', 'ONSAS_VERSION'];

/**
 * Controller for ons-actionslider.
 *
 * A container for all action events.
 */
function OnsActionsliderController (onsActionSocket, $element, $scope, $filter, $timeout, $log, $q, $window, ONSAS_VERSION) {
  var version = readFromSessionStorage('onsas-v', null);
  var $ul = $element.find('ul');
  var sessionId = readFromSessionStorage('onsas-i', null);
  var sessionTimestamp = readFromSessionStorage('onsas-t', Date.now());
  var internalQueue = readFromSessionStorage('onsas-q', []);
  var channels = JSON.parse('[' + $scope.channels + ']');
  var lastTimestamp = null;
  var userIdentification = {
    id: $scope.userId,
    productId: $scope.productId
  };

  $log.debug('actionSlider client version', ONSAS_VERSION);

  $scope.maxActions = $scope.maxActions || 60;
  $scope.lifetime = $scope.lifetime || 300;
  $scope.currentOffset = 0;
  $scope.actions = readFromSessionStorage('onsas-a', []);
  $scope.updateOffset = updateOffset;

  $window.onbeforeunload = onBeforeUnload($window.onbeforeunload);

  $scope.$watch('language', updateLanguage);

  if (version !== ONSAS_VERSION) {
    sessionTimestamp = Date.now();
    internalQueue = [];
    $scope.actions = [];
  }

  if (sessionId !== $scope.actionSession) {
    sessionTimestamp = Date.now();
    internalQueue = [];
    $scope.actions = [];
  }

  lastTimestamp = $scope.actions.reduce(function (accumulator, action) {
    return action.timestamp > accumulator
      ? action.timestamp
      : accumulator;
  }, lastTimestamp);

  lastTimestamp = internalQueue.reduce(function (accumulator, action) {
    return action.timestamp > accumulator
      ? action.timestamp
      : accumulator;
  }, lastTimestamp);

  if (Array.isArray(channels)) {
    if (Array.isArray(channels[0])) {
      channels = channels[0];
    }
  } else {
    channels = [];
  }

  $log.debug('You are ' + $scope.productId + '@' + $scope.userId + ', listening to public channel(s) ' + channels.join(', '));

  onsActionSocket
    .create($scope.actionService)
    .connect(userIdentification, channels, lastTimestamp)
    .addOnMessage(onMessage);

  $timeout(processQueue, 0);

  return this;

  function updateLanguage(newLanguage, oldLanguage) {
    $log.debug('updateLanguage', newLanguage, oldLanguage);

    if (newLanguage === oldLanguage) {
      return;
    }

    $scope.$evalAsync(function () {
      $q.when($scope.actions)
        .then(function (actions) {
          return actions.map(function (action) {
            return $scope.onAction({ action: action, language: $scope.language });
          })
        })
        .then(function (actions) {
          return $q.all(actions);
        })
        .then(function (actions) {
          return actions.map(function (action) {
            if(!action) return action;
            action.classes = actionClasses(action);

            return action;
          });
        })
        .then(function (actions) {
          $scope.actions = actions;
        })
        .catch($log.warn.bind($log))
    });

  }

  /**
   * Called upon an incoming action.
   */
  function onMessage (action) {
    $log.debug('onsas new action', action);

    internalQueue.push(action);
  }

  /**
   * Called at regular intervals to add actions from the queue (que) to the actual, visible list of actions.
   */
  function processQueue () {
    $scope.$evalAsync(function () {
      var action;
      var css;

      for (action = internalQueue.shift(); action && action.timestamp <= sessionTimestamp; action = internalQueue.shift()) {
        addAction(action);
      }

      $timeout(function () {
        $ul.removeClass('onsas-no-anim');

        if (action) {
          addAction(action);

          $scope.currentOffset = 0;
        }

        $scope.actions.forEach(function (action) {
          action.classes = actionClasses(action);
        });

        updateOffset(0);
      }, 666);
    });

    $timeout(processQueue, 1500);
  }

  function addAction (action) {
    $q.when($scope.onAction({ action: action, language: $scope.language }))
      .then(function (displayAction) {
        if (displayAction) {
          displayAction.classes = actionClasses(displayAction);
        }
        return displayAction;
      })
      .then(function (displayAction) {
        if (displayAction) {
          $scope.actions.push(displayAction);

          $scope.actions = $filter('orderBy')($scope.actions, 'timestamp');

          $scope.actions.length > $scope.maxActions && $scope.actions.splice(0, $scope.actions.length - $scope.maxActions);
        }
      })
      .catch($log.warn.bind($log));
  }

  /**
   * Update the current offset
   */
  function updateOffset (offsetRelativeToNewestAction) {
    var css;

    switch (offsetRelativeToNewestAction) {
      case 'first':
        $scope.currentOffset = $scope.actions.length;
        break;

      case 'last':
        $scope.currentOffset = 0;
        break;

      default:
        $scope.currentOffset += offsetRelativeToNewestAction;
    }

    if ($scope.currentOffset < 0) {
      $scope.currentOffset = 0;
    }

    if ($scope.currentOffset >= $scope.actions.length) {
      $scope.currentOffset = $scope.actions.length - 1;
    }

    if ($scope.currentOffset === 0) {
      $element.addClass('onsas-last-reached');
    } else {
      $element.removeClass('onsas-last-reached');
    }

    if ($scope.currentOffset === $scope.actions.length - 1) {
      $element.addClass('onsas-first-reached');
    } else {
      $element.removeClass('onsas-first-reached');
    }

    $q.when($scope.onScroll({offset: $scope.currentOffset, children: childSizes()}))
      .then(function (css) {
        if (typeof css === 'string' || typeof css === 'object') {
          $ul.css(css);
        }
      })
      .catch($log.warn.bind($log));
  }

  function childSizes () {
    var children = $ul.children();
    var childSizes = [];
    var childIndex;

    for (childIndex = 0; childIndex < children.length; ++childIndex) {
      childSizes.push({
        width: angular.element(children[childIndex]).width(),
        height: angular.element(children[childIndex]).height()
      });
    }

    return childSizes;
  }

  /**
   * Determine action styles
   */
  function actionClasses (action) {
    var classes = action.classes || {};

    classes['onsas-' + action.id] = true;
    classes['onsas-old'] = action.timestamp + $scope.lifetime * 1000 < Date.now();
    classes['onsas-has-action'] = angular.isDefined(classes.hasAction) ? classes.hasAction : true;

    return classes;
  }

  function onBeforeUnload (oldBeforeUnload) {
    return function () {
      writeToSessionStorage('onsas-i', $scope.actionSession);
      writeToSessionStorage('onsas-t', sessionTimestamp);
      writeToSessionStorage('onsas-q', internalQueue);
      writeToSessionStorage('onsas-a', $scope.actions);
      writeToSessionStorage('onsas-v', ONSAS_VERSION);

      angular.isFunction(oldBeforeUnload) && oldBeforeUnload.apply($window, arguments);
    };
  }

  function writeToSessionStorage (key, data) {
    var sessionStorage = detectStorage();

    $log.debug('onsas serializing', key, data);

    return sessionStorage.put(key, data);
  }

  function readFromSessionStorage (key, defaultValue) {
    var sessionStorage = detectStorage();
    var value;

    value = sessionStorage.get(key) || defaultValue;

    $log.debug('onsas unserializing', key, value);

    return value;
  }

  function detectStorage () {
    var storage;
    var helper;

    try {
      storage = testStorage('sessionStorage');

      helper = {
        put: function (key, value) {
          try {
            storage.setItem(key, JSON.stringify(value));
          } catch (e) {
            $log.warn(e);
          }
        },
        get: function (key) {
          try {
            return JSON.parse(storage.getItem(key));
          } catch (e) {
            $log.warn(e);

            return null;
          }
        },
        del: function (key) {
          try {
            storage.removeItem(key);
          } catch (e) {
            $log.warn(e);
          }
        }
      };
    } catch (ex) {
      $log.warn(ex);

      helper = {
        put: function () {
        },
        get: function () {
        },
        del: function () {
        }
      };
    }

    detectStorage = function () {
      return helper;
    };

    return helper;
  }

  function testStorage (type) {
    var testKey = 'onsas-test-key';
    var testValue = '__storage_test__';
    var storage = window[type];

    if (!storage) {
      throw 'No ' + type;
    }

    storage.setItem(testKey, testValue);

    if (storage.getItem(testKey) !== testValue) {
      throw 'Error writing/reading to/from ' + type;
    }

    storage.removeItem(testKey);

    return storage;
  }
}

onsAction.$inject = [];

/**
 * ons-action element.
 *
 * Directive for each element in ons-actionslider
 */
function onsAction () {
  return {
    restrict: 'A',
    require: '^^onsActionslider',
    template: [
      '<div class="onsas-outer" ng-style="action.styles">',
      '<div class="onsas-inner">',
      '<span class="onsas-title">', '{{ action.title }}', '</span>',
      '<span class="onsas-message">', '{{ action.text }}', '</span>',
      '</div>',
      '</div>'
    ].join('')
  };
}

onsActionSocket.$inject = ['SockJS', '$timeout', '$log'];

/**
 * Socket factory to re-/connect to ratatoskr.
 */
function onsActionSocket (SockJS, $timeout, $log) {
  var factory = {};

  factory.create = create;

  return factory;

  function create (server) {
    var socket = null;
    var service = {};
    var _onMessageHandler = [];
    var _messageBuffer = [];
    var _connected = false;
    var _registerData = null;

    service.connect = connect;
    service.addOnMessage = addOnMessage;

    openSocket();

    return service;

    function connect (user, publicChannels, lastAction) {
      _registerData = {
        user: user,
        channels: publicChannels,
        lastAction: lastAction
      };

      $log.debug('onsas registrationData', _registerData);

      return sendRegisterData();
    }

    function addOnMessage (func) {
      if (angular.isFunction(func)) {
        _onMessageHandler.push(func);
      }

      return service;
    }

    function onOpen () {
      _connected = true;

      sendBuffered();
      sendRegisterData();
    }

    function onMessage (action) {
      var data = JSON.parse(action.data);

      data.payload = data.payload || {};
      data.timestamp = data.timestamp || action.timeStamp || Date.now();
      _registerData.lastAction = data.timestamp;

      _onMessageHandler.forEach(function (handler) {
        handler(data);
      });
    }

    function onClose () {
      _connected = false;

      $timeout(openSocket, 3333);
    }

    function openSocket () {
      socket = new SockJS(server + '/as');

      socket.onopen = onOpen;
      socket.onclose = onClose;
      socket.onmessage = onMessage;
    }

    function sendRegisterData () {
      _connected && _registerData !== null && send(false)(_registerData);

      return service;
    }

    function send (buffer) {
      return function (data) {
        if (_connected) {
          socket.send(JSON.stringify(data));
        } else if (buffer !== false) {
          _messageBuffer.push(data);
        }
      };
    }

    function sendBuffered () {
      var messageBufferClone = JSON.parse(JSON.stringify(_messageBuffer));

      _messageBuffer = [];

      messageBufferClone.forEach(send(true));
    }
  }
}
